import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArtist = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9544_90)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M16 13.6667C16 13.6667 16 13.6687 16 13.6693C16 14.59 15.254 15.336 14.3333 15.336C13.4127 15.336 12.6667 14.59 12.6667 13.6693C12.6667 12.7487 13.4127 12.0027 14.3333 12.0027C14.4473 12.0027 14.5587 12.0147 14.6667 12.036V9.42467C14.6667 9.22867 14.5847 9.05 14.4367 8.92133C14.288 8.79267 14.1007 8.738 13.9053 8.76467L12.192 9.00933C11.7027 9.07933 11.3333 9.50533 11.3333 9.99933V14.3353C11.3333 15.256 10.5873 16.002 9.66667 16.002C8.746 16.002 8 15.256 8 14.3353C8 13.4147 8.746 12.6687 9.66667 12.6687C9.78067 12.6687 9.892 12.6807 10 12.702V9.99933C10 8.846 10.8613 7.85267 12.0033 7.68933L13.7173 7.44467C14.2913 7.36133 14.872 7.53333 15.3107 7.914C15.7487 8.294 16 8.84467 16 9.42467V13.6667ZM1.33333 4C1.33333 1.794 3.12733 0 5.33333 0C7.53933 0 9.33333 1.794 9.33333 4C9.33333 6.206 7.53933 8 5.33333 8C3.12733 8 1.33333 6.206 1.33333 4ZM2.66667 4C2.66667 5.47067 3.86267 6.66667 5.33333 6.66667C6.804 6.66667 8 5.47067 8 4C8 2.52933 6.804 1.33333 5.33333 1.33333C3.86267 1.33333 2.66667 2.52933 2.66667 4ZM8.618 10.638C8.75667 10.2967 8.59133 9.908 8.25067 9.77C7.53533 9.48 6.778 9.33333 6.00067 9.33333C2.692 9.33333 0 12.0253 0 15.3333C0 15.7013 0.298667 16 0.666667 16C1.03467 16 1.33333 15.7013 1.33333 15.3333C1.33333 12.76 3.42667 10.6667 6 10.6667C6.60533 10.6667 7.19467 10.7807 7.75 11.0053C8.09133 11.1433 8.48 10.9787 8.618 10.638Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9544_90",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgArtist;
